<template>
  <div>
    <roster-calendar></roster-calendar>
  </div>
</template>
<script>
import RosterCalendar from "./RosterCalendar";
export default {
  components: {
    RosterCalendar
  }
};
</script>
